import { type ComponentProps, type FC, type ForwardedRef } from "react";
import { Button } from "@root/shared/components/Button";
import { Icon } from "@root/shared/components/Icon";
import { ShopWorksModal } from "@userFrontend/features/publication/components/ShopWorksModal";
import { Cassette } from "./uiParts/Cassette";
import * as styles from "./styles.css";
import { GA_SHOW_OTHER_JOBS_ACTION } from "./constants";

type Props = {
  workCode: string;
  shops: Omit<ComponentProps<typeof Cassette>, "detailWorkCode" | "shopId">[];
  isOpenModal: boolean;
  totalCount: number;
  handleOpenModal: () => void;
  handleCloseModal: () => void;
  // modal
  brandName: string;
  businessType: string;
  occupation: string;
  isShowIndicator: boolean;
  indicatorRef: ForwardedRef<HTMLDivElement>;
};

const DEFAULT_SHOW_LENGTH = 2;

export const Presentation: FC<Props> = ({
  workCode,
  shops,
  isOpenModal,
  totalCount,
  handleOpenModal,
  handleCloseModal,
  brandName,
  businessType,
  occupation,
  isShowIndicator,
  indicatorRef,
}) => {
  return (
    <section className={styles.outer}>
      <h2 className={styles.heading}>この企業の別の求人</h2>
      <div className={styles.cassettesOuter}>
        {shops.map((shop, index) => {
          if (index >= DEFAULT_SHOW_LENGTH) return null;
          return (
            <div key={shop.docId} className={styles.cassetteOuter}>
              <Cassette {...shop} detailWorkCode={workCode} hasBorder isShowLocationOnlyOneLine />
            </div>
          );
        })}
      </div>
      {shops.length > DEFAULT_SHOW_LENGTH && (
        <>
          <div className={styles.buttonOuter} data-ga-action={GA_SHOW_OTHER_JOBS_ACTION}>
            <Button
              onClick={handleOpenModal}
              theme="tertiary"
              rightIcon={<Icon name="arrow-bold-right" />}
              className={styles.button}
            >
              <span>
                <span className={styles.shopLength}>{totalCount}</span> 店舗すべての求人を見る
              </span>
            </Button>
          </div>
          <ShopWorksModal
            isShow={isOpenModal}
            brandName={brandName}
            businessTypeAndOccupation={`${businessType} / ${occupation}`}
            totalNumber={totalCount}
            handleCloseModal={handleCloseModal}
          >
            <>
              {shops.map((shop) => (
                <div key={shop.docId} className={styles.modalCassetteOuter}>
                  <Cassette {...shop} detailWorkCode={workCode} />
                </div>
              ))}
              {isShowIndicator && (
                <div className={styles.loadingContainer}>
                  <div className={styles.loadingSpinner} ref={indicatorRef} />
                </div>
              )}
            </>
          </ShopWorksModal>
        </>
      )}
    </section>
  );
};
